import React, { useEffect } from "react";
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useAuth } from "../components/msalAuth/AuthProvider";
import { IdleTimerProvider } from "../components/idle/IdleTimerProvider";
import Loader from "../components/configure/Loader";
import { isValidRedirectPath } from "../components/configure/utils";

export default function PrivateRouteWalkin({ children }) {
  const { login, isAuthenticated } = useAuth();
  const { inProgress } = useMsal();

  useEffect(() => {
    if (!isAuthenticated) {
      const timer = setTimeout(() => {
        const currentPath = window.location.pathname;
        const redirectPath = isValidRedirectPath(currentPath) ? currentPath : "/";
        sessionStorage.setItem("wk_redirect", redirectPath);
        login();
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, login]);

  return (
    <>
      <AuthenticatedTemplate>
        {inProgress === "none" ? <IdleTimerProvider>{children}</IdleTimerProvider> : <Loader message="Authenticating......" />}
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Loader message="Redirecting to login..." />
      </UnauthenticatedTemplate>
    </>
  );
}
